import type { Writing, WritingBlock } from "./types";

const base = "/writings/drawing-with-claude";

const body: WritingBlock[] = [
  {
    type: "paragraph",
    text: "Lately I've been making drawings by writing code with Claude. I describe a scene in plain words, and we shape it line by line until it feels right.",
  },
  {
    type: "paragraph",
    text: "There's no canvas and no brush. Each picture is just instructions — strokes, hatching, and a little randomness — rendered into something that looks hand-drawn. Here are a few I liked.",
  },
  { type: "heading", text: "Chair and sun" },
  {
    type: "image",
    image: {
      src: `${base}/01-chair-and-sun.png`,
      alt: "A blue line-drawn sail beside a radiating sun, floating above a dashed horizon and a vanishing-point grid on a warm cream background.",
    },
  },
  { type: "heading", text: "Boat on water" },
  {
    type: "image",
    image: {
      src: `${base}/02-boat-on-water.png`,
      alt: "A small blue sailboat drawn in horizontal strokes, resting on a rippled sea beside a line-burst sun under a pale blue sky.",
    },
  },
  { type: "heading", text: "Cherry blossom" },
  {
    type: "image",
    image: {
      src: `${base}/03-cherry-blossom.png`,
      alt: "A five-petal cherry blossom sketched in blue dashed lines on a soft pink background, with faint ghost blossoms scattered around it.",
    },
  },
  { type: "heading", text: "Stone garden" },
  {
    type: "image",
    image: {
      src: `${base}/04-sakura-road.png`,
      alt: "A topographic landscape of clustered stones and contour lines with a winding sand-colored path, drawn in muted greens and grays.",
    },
  },
  { type: "heading", text: "Mount Fuji" },
  {
    type: "image",
    image: {
      src: `${base}/05-mount-fuji.png`,
      alt: "Mount Fuji rendered in dense blue hatching with a white snow cap, sitting on a sandy cream plain.",
    },
  },
];

const writing: Writing = {
  slug: "drawing-with-claude",
  title: "Drawing with Claude",
  date: "2026",
  lastUpdated: "6/18/26",
  description: "A small series of drawings made by writing code with Claude.",
  placeholder: body
    .filter((block): block is Extract<WritingBlock, { type: "paragraph" }> => block.type === "paragraph")
    .map((block) => block.text),
  body,
};

export default writing;
